import React from 'react';
import { Box, styled } from '@mui/system';

import useSiteHoverCard from '../SiteHoverCard';

const FaviconImg = styled('img')({
  width: 22,
  height: 22,
  borderRadius: 4,
  flexShrink: 0,
  objectFit: 'contain',
});

const FaviconLetter = styled(Box)({
  width: 22,
  height: 22,
  borderRadius: 4,
  flexShrink: 0,
  background: '#f5f5f5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 13,
  fontWeight: 700,
  color: '#666',
});

// Shared wiring for anything that stands in for a site on a card: clicking
// opens the site page, hovering reveals the site hovercard with its own
// open/filter actions.
function useSiteTrigger({
  site, id, domain, onSiteView, onSiteFilter, placement,
}) {
  const canClick = Boolean(id != null && onSiteView);
  const onCardOpen = canClick ? () => onSiteView(id, domain) : undefined;
  const onCardFilter = id != null && onSiteFilter
    ? () => onSiteFilter(id, domain)
    : undefined;
  const { triggerProps, popper, close } = useSiteHoverCard(site, {
    onCardOpen,
    onCardFilter,
    placement,
  });
  const handleClick = (e) => {
    e.stopPropagation();
    if (!canClick) return;
    close();
    onSiteView(id, domain);
  };

  return { canClick, triggerProps, popper, handleClick };
}

export function SiteFavicon({
  site, id, domain, logoUrl, letter, onSiteView, onSiteFilter,
}) {
  const { canClick, triggerProps, popper, handleClick } = useSiteTrigger({
    site, id, domain, onSiteView, onSiteFilter, placement: 'bottom-start',
  });
  const cursor = canClick ? 'pointer' : 'default';

  return (
    <>
      {logoUrl ? (
        <FaviconImg
          src={logoUrl}
          alt=""
          sx={{ cursor }}
          {...triggerProps}
          onClick={handleClick}
        />
      ) : (
        <FaviconLetter sx={{ cursor }} {...triggerProps} onClick={handleClick}>
          {letter}
        </FaviconLetter>
      )}
      {popper}
    </>
  );
}

export function SiteNameHover({
  site, id, domain, name, onSiteView, onSiteFilter, sx, className,
}) {
  const { canClick, triggerProps, popper, handleClick } = useSiteTrigger({
    site, id, domain, onSiteView, onSiteFilter, placement: 'bottom-start',
  });

  return (
    <>
      <Box
        component="span"
        className={className}
        {...triggerProps}
        onClick={handleClick}
        sx={{ cursor: canClick ? 'pointer' : 'default', ...sx }}
      >
        {name}
      </Box>
      {popper}
    </>
  );
}
